// extracted by mini-css-extract-plugin
module.exports = {"header":"_1SYSF2cd","logo":"_3LcdorGj","nav":"_3Yto9mk8"};